import React from 'react';
import { useIntl } from '../../util/reactIntl';

import css from './FAQPage.module.css';
import { PrimaryButton } from '../../components';

function SectionGetInTouch() {
  const intl = useIntl();
  const supportEmail = 'info@swimmarketplace.com';

  const handleEmailClick = () => {
    window.location.href = `mailto:${supportEmail}`;
  };

  return (
    <div className={css.getInTouchWrapper}>
      <div className={css.getInTouchContent}>
        <div className={css.sectionHeader}>

          {/* <h1>{intl.formatMessage({ id: 'SectionGetInTouch.title', defaultMessage: 'Still have questions?' })}</h1> */}

          <p>
            {intl.formatMessage(
              {
                id: 'SectionGetInTouch.description',
                defaultMessage: 'Email us at {email}.',
              },
              {
                email: (
                  <a href={`mailto:${supportEmail}`} className={css.supportEmailLink}>
                    {supportEmail}
                  </a>
                ),
              }
            )}
          </p>

          <div className={css.heroButtonSec}>
            <PrimaryButton type="button" className={css.borderButton} onClick={handleEmailClick}>
              {intl.formatMessage({ id: 'SectionGetInTouch.cta', defaultMessage: 'Get in touch' })}
            </PrimaryButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionGetInTouch;
